//frontend/src/components/user/Profile.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { User, Mail, Calendar, Package, Lock, Edit, Phone, MapPin } from 'lucide-react';

export default function Profile() {
    const { user } = useSelector(state => state.authState);

    return (
        <div className="w-full" style={{
            backgroundImage: `url('https://meatbuddy-assets.s3.eu-north-1.amazonaws.com/other-images/meatbuddy-image-web-banner-background-5.png')`,
            backgroundRepeat: 'repeat',
            backgroundSize: 'auto',
            backgroundPosition: 'center'
        }}>
            <div className="max-w-6xl mx-auto px-4 py-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    {/* Left Section - Avatar and Buttons */}
                    <div className="md:col-span-1 flex flex-col items-center">
                        <div className="relative">
                            <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-[#dc2626]">
                                <img 
                                    src={user.avatar ?? './images/default_avatar.png'} 
                                    alt="Profile" 
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <Link 
                                to="/myprofile/update" 
                                className="absolute bottom-0 right-0 bg-[#dc2626] text-white p-1.5 rounded-full hover:bg-[#dc2626]/90 transition-colors"
                            >
                                <Edit className="w-3.5 h-3.5" />
                            </Link>
                        </div>
                        
                        {/* Edit Profile Button */}
                        <Link 
                            to="/myprofile/update" 
                            className="mt-4 w-full max-w-[180px] px-4 py-2 bg-[#dc2626] text-white rounded-lg hover:bg-[#dc2626]/90 transition-colors flex items-center justify-center gap-2 font-medium text-sm"
                        >
                            <Edit className="w-3.5 h-3.5" />
                            Edit Profile
                        </Link>
                        
                        {/* My Orders Button */}
                        <Link 
                            to="/orders" 
                            className="mt-4 w-full max-w-[180px] px-4 py-2 bg-[#dc2626] text-white rounded-lg hover:bg-[#dc2626]/90 transition-colors flex items-center justify-center gap-2 font-medium text-sm"
                        >
                            <Package className="w-3.5 h-3.5" />
                            My Orders
                        </Link>
                        
                        {/* Change Password Button */}
                        <Link 
                            to="/myprofile/update/password" 
                            className="mt-4 w-full max-w-[180px] px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 font-medium text-sm whitespace-nowrap"
                        >
                            <Lock className="w-3.5 h-3.5" />
                            Change Password
                        </Link>
                    </div>

                    {/* Right Section - User Info */}
                    <div className="md:col-span-3">
                        <h2 className="font-['Crimson_Text'] text-2xl font-bold text-red-600 mb-4">Profile Information</h2>
                        
                        <div className="space-y-4">
                            <div className="flex items-center">
                                <div className="w-10 h-10 rounded-full bg-[#dc2626]/10 flex items-center justify-center">
                                    <User className="w-5 h-5 text-[#dc2626]" />
                                </div>
                                <div className="ml-4">
                                    <p className="text-xs text-gray-500">Full Name</p>
                                    <p className="text-base font-medium text-gray-800">{user.name}</p>
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-10 h-10 rounded-full bg-[#dc2626]/10 flex items-center justify-center">
                                    <Mail className="w-5 h-5 text-[#dc2626]" />
                                </div>
                                <div className="ml-4">
                                    <p className="text-xs text-gray-500">Email Address</p>
                                    <p className="text-base font-medium text-gray-800">{user.email}</p>
                                </div>
                            </div>

                            {/* Phone Number */}
                            <div className="flex items-center">
                                <div className="w-10 h-10 rounded-full bg-[#dc2626]/10 flex items-center justify-center">
                                    <Phone className="w-5 h-5 text-[#dc2626]" />
                                </div>
                                <div className="ml-4">
                                    <p className="text-xs text-gray-500">Phone Number</p>
                                    <p className="text-base font-medium text-gray-800">{user.phone}</p>
                                </div>
                            </div>

                            {/* Address */}
                            <div className="flex items-start">
                                <div className="w-10 h-10 rounded-full bg-[#dc2626]/10 flex items-center justify-center mt-1">
                                    <MapPin className="w-5 h-5 text-[#dc2626]" />
                                </div>
                                <div className="ml-4">
                                    <p className="text-xs text-gray-500">Address</p>
                                    <p className="text-base font-medium text-gray-800">{user.address || 'Not provided'}</p>
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-10 h-10 rounded-full bg-[#dc2626]/10 flex items-center justify-center">
                                    <Calendar className="w-5 h-5 text-[#dc2626]" />
                                </div>
                                <div className="ml-4">
                                    <p className="text-xs text-gray-500">Joined</p>
                                    <p className="text-base font-medium text-gray-800">
                                        {String(user.createdAt).substring(0, 10)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}